<template>
  <div>
    <div class="card" v-if="result.entities">
      <div class="card-header">Contacts</div>
      <div class="card-body">
        <template v-for="entity in result.entities">
          <div v-if="entity.roles" :key="entity.handle">
            <h5>{{parseEntityName(entity)}} Contact</h5>
            <template v-if="entity.remarks">
              <p
                v-for="(remark, label) in entity.remarks"
                :key="''+remark.description"
              >{{remark.description.join(' ')}}</p>
            </template>
            <table class="table">
              <tbody>
                <tr v-if="entity.handle">
                  <th scope="row" width="120px">Handle</th>
                  <td>
                    <router-link
                      tag="a"
                      :to="'/entity/' + entity.handle"
                      class="query"
                      id="handle"
                    >{{entity.handle}}</router-link>
                  </td>
                </tr>
              </tbody>
            </table>

            <template v-if="entity.vcardArray">
              <apnic-vcard :cardArray="entity.vcardArray"></apnic-vcard>
            </template>
          </div>
        </template>
      </div>
    </div>

    <div class="card" v-if="result.vcardArray">
      <div class="card-header">Contact Information</div>
      <div class="card-body">
        <apnic-vcard :cardArray="result.vcardArray"></apnic-vcard>
      </div>
    </div>
  </div>
</template>

<script>
import VCard from "./VCard";

export default {
	props: ["result"],
	data() {
		return {
			entityTypes: {
				registrant: "Registrant",
				technical: "Technical",
				administrative: "Administrative",
				abuse: "Abuse",
				billing: "Billing",
				registrar: "Registrar",
				reseller: "Reseller",
				sponsor: "Sponsor",
				proxy: "Proxy",
				notifications: "Notifications",
				noc: "NOC"
			}
		};
	},
	methods: {
		parseEntityName(entity) {
			let entityName = this.entityTypes[entity.roles[0]];
			const entityLength = entity.roles.length;
			if (entityLength === 2) {
				entityName += " and " + this.entityTypes[entity.roles[1]];
			} else if (entityLength > 2) {
				for (var i = 0; i < entityLength; i++) {
					if (i === entityLength - 1) {
						entityName += " and " + this.entityTypes[entity.roles[i]];
					} else {
						entityName += ", " + this.entityTypes[entity.roles[i]];
					}
				}
			}
			return entityName;
		}
	},
	components: {
		"apnic-vcard": VCard
	}
};
</script>

<style scoped lang="scss">
#js-results h6 {
	color: black;
	font-size: 1rem;
}
</style>
